import { createStyles } from "@mantine/core"
import { CSSProperties } from "react"

interface DefaultProps {
    children: JSX.Element | JSX.Element[]
    style?: CSSProperties
    className?: string
    loading?: boolean
    row?: boolean
}

const useStyles = createStyles((theme) => ({
    container: {
        maxWidth: theme.other.containerSize,
        margin: 'auto',
        width: '100%',
    },
    row: {
        display: 'flex',
        flexDirection: 'row'
    },
    column: {
        display: 'flex',
        flexDirection: 'column'
    },
}))

const DefaultContainer = (props: DefaultProps) => {
    const { classes } = useStyles()
    const load = props.loading ?? false
    const row = props.row ?? false
    return (
        <div className={`${classes.container} ${props.className ?? ''} ${row ? classes.row : classes.column}`} style={props.style}>
            {load ? <></> : props.children}
        </div>
    )
}

export default DefaultContainer